import React from 'react';

const SaveIcon = ({ width = 40, height = 41, color = '#00a4e3' }) => {
  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="System / Save">
        <path
          id="Vector"
          d="M28.3333 35.5003L11.6667 35.5M28.3333 35.5003L29.6718 35.5C31.535 35.5 32.4667 35.5 33.179 35.137C33.8062 34.8175 34.3175 34.3072 34.637 33.68C35 32.9677 35 32.035 35 30.1718V15.8659C35 15.1179 35 14.742 34.9202 14.3851C34.8491 14.0667 34.7321 13.7609 34.572 13.4766C34.3943 13.1612 34.145 12.8842 33.6549 12.3396L29.0628 7.23735C28.4948 6.60623 28.2069 6.28635 27.8613 6.05664C27.5504 5.85001 27.2071 5.69764 26.8455 5.60478C26.4375 5.5 25.9997 5.5 25.1251 5.5H10.3337C8.46682 5.5 7.5327 5.5 6.81966 5.86331C6.19245 6.18289 5.68289 6.69245 5.36331 7.31966C5 8.0327 5 8.96682 5 10.8337V30.167C5 32.0338 5 32.966 5.36331 33.679C5.68289 34.3062 6.19245 34.8175 6.81966 35.137C7.532 35.5 8.46499 35.5 10.3282 35.5H11.6667M28.3333 35.5003V29.1615C28.3333 27.2983 28.3333 26.3653 27.9704 25.653C27.6508 25.0258 27.1395 24.5162 26.5123 24.1966C25.7993 23.8333 24.8672 23.8333 23.0003 23.8333H17.0003C15.1335 23.8333 14.1994 23.8333 13.4863 24.1966C12.8591 24.5162 12.3496 25.0258 12.03 25.653C11.6667 26.366 11.6667 27.3002 11.6667 29.167V35.5M25 12.1667H15"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default React.memo(SaveIcon);
